/**
 * Sample biomarker distribution shown in the membership-page overlays (the
 * "81 biomarkers → 12 optimal / 67 normal / 2 out of range" tile). These are
 * illustrative sample-report figures, not product data — but the three counts
 * MUST sum to the headline total and the distribution bar is sized from them.
 *
 * Single source of truth: previously the counts + the 81 total were hand-typed
 * across four call sites (BiomarkerCard, HealthReportCard, and two identical
 * BiomarkerOverlay copies), so a correction had to land three-plus times (see
 * PRs #2718/#2726). Change the numbers here and every overlay follows.
 */
export const BIOMARKER_SAMPLE = {
  optimal: 12,
  normal: 67,
  outOfRange: 2,
} as const

export const BIOMARKER_SAMPLE_TOTAL =
  BIOMARKER_SAMPLE.optimal +
  BIOMARKER_SAMPLE.normal +
  BIOMARKER_SAMPLE.outOfRange
